const tables = document.querySelectorAll('.typography table');

export const typography = () => {
    // wrap tables
    if (tables.length) {
        tables.forEach(table => {
            let wrapper = document.createElement('div');
            wrapper.classList.add('table-responsive');
            table.parentNode.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }
};